import connect from 'react-redux/es/connect/connect';

import { loginAsCustomerWithId } from '../actions/user';
import BookingsListPage from '../pages/bookingslistpage/BookingsListPage';

const mapStateToProps = state => {
    return {
        customer: state.user.customer,
        cartItemCount: state.cart.cartItems.length
    };
};

const mapDispatchToProps = dispatch => ({
    loginAsCustomerWithId: (customerId, showModal, onError, onSuccess) => {
        dispatch(loginAsCustomerWithId(customerId, showModal, onError, onSuccess));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingsListPage);
